// core
import React from "react";
import cx from "classnames";
import InsurerLogo from "../../../../../common/components/InsurerLogo/InsurerLogo";
import QuoteCallToAction from "../../Components/QuoteCallToAction/QuoteCallToAction";
import Premium from "../../../Premium/Premium";
import QuoteTableState from "../../../../types/quoteTable/IQuoteTableState";
import IQuoteCardResult from "../../../../interfaces/results/IQuoteCardResult";
import { QuoteTableCallToActionFunction } from "../../../../hooks/useQuoteSections";
import { PaymentFrequency } from "../../../../../common/interfaces/enums/PaymentFrequency";

// interfaces
interface IQuoteTableHeaderContentProps {
    quoteState: QuoteTableState;
    bannerHeadingText: string;
    result: IQuoteCardResult;
    handleSelectProduct: QuoteTableCallToActionFunction;
    handlePaymentFrequencyChange: (paymentFreq: PaymentFrequency) => Promise<void>;
    applicationURL: string;
    groupId: string;
}

// rendering
const QuoteTableHeaderContent: React.FC<IQuoteTableHeaderContentProps> = (props) => {
    const {
        result,
        // handleSelectProduct,
        handlePaymentFrequencyChange,
        quoteState,
        applicationURL,
        groupId
    } = props;

    const {
        result: { providerId, totalPremium, paymentFrequency, errors }
    } = result;

    return (
        <React.Fragment>
            <Premium
                totalPremium={totalPremium}
                size="large"
                paymentFrequency={paymentFrequency}
                isBelowMinimumPremium={!quoteState.isOverMinimumPremium}
                onPaymentFrequencyChange={handlePaymentFrequencyChange}
                hasBlockingError={quoteState.hasBlockingError}
            />

            <InsurerLogo
                includesAboutInsurerModal
                providerId={providerId}
                className={cx(["layout-insurer-logo--sticky"])}
            />

            {!quoteState.hasBlockingError ? (
                <QuoteCallToAction
                    groupId={groupId}
                    card={result}
                    className={"hide-tablet"}
                    isDisabled={
                        quoteState.hasBlockingError ||
                        !quoteState.isOverMinimumPremium ||
                        quoteState.isDisabled
                    }
                    url={applicationURL}
                    premium={totalPremium}
                />
            ) : (
                <div className={cx("layout-flex-row")}>
                    <span className={cx("space-m")}>Insurer not available. </span>
                </div>
            )}
        </React.Fragment>
    );
};

export default React.memo(QuoteTableHeaderContent);
